import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import abbreviateNumber from 'core/utils/abbreviateNumber';
import { FlexCol } from 'core/styles';
import { UpVoteIcon, DownVoteIcon, VoteBtn, VoteCount, BounceWrapper } from './votingStyles';

class Voting extends PureComponent {
	handleVote(upVote = true) {
		this.props.onVote(upVote);
	}

	render() {
		const { activeVote, upVotes, downVotes } = this.props;
		const hasUpVote = activeVote === "up";
		const hasDownVote = activeVote === "down";
		let voteCount = upVotes - downVotes + 1; // implicit +1 for asking the question
		if (hasUpVote) voteCount += 1;
		if (hasDownVote) voteCount -= 1;
		return (
			<FlexCol centered>
				<VoteBtn onClick={() => this.handleVote()}>
					<BounceWrapper up bounce={hasUpVote}>
						<UpVoteIcon />
					</BounceWrapper>
				</VoteBtn>
				<VoteCount>
					{abbreviateNumber(voteCount)}
				</VoteCount>
				<VoteBtn onClick={() => this.handleVote(false)}>
					<BounceWrapper bounce={hasDownVote}>
						<DownVoteIcon />
					</BounceWrapper>
				</VoteBtn>
			</FlexCol>
		);
	}
}

Voting.propTypes = {
	activeVote: PropTypes.oneOf(["up", "down"]),
	upVotes: PropTypes.number,
	downVotes: PropTypes.number,
	onVote: PropTypes.func,
};

Voting.defaultProps = {
	activeVote: null,
	upVotes: 0,
	downVotes: 0,
	onVote: () => null,
};

export default Voting;
